import React from 'react'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'

import Styles from './EmptyCampaignsPage.module.scss'

const EmptyCampaignsPage = () => {
  const { t } = useTranslation()

  return (
    <div className={Styles.empty} data-testid="empty-campaigns-page">
      <Text variant="heading-04">{t('marketing.campaigns.empty-title')}</Text>
      <Text variant="subtitle" align="center">
        {t('marketing.campaigns.empty-description')}
      </Text>
    </div>
  )
}

export default EmptyCampaignsPage
